import React from 'react';
import { Box } from '@mui/material';

import { useAuth } from 'hooks/use-auth';
import { Equipment } from 'models';
import {
  EquipmentHistoryChart,
  EquipmentPieChart,
  EquipmentTimelineChart,
} from 'components/chart';


interface Props {
  equipment?: Equipment
}

export default function EquipmentStatusPage({equipment}: Props) {
  const auth = useAuth();

  return (
    <>
    {equipment && (
      <Box>
        <EquipmentPieChart
          companyId={auth.companyId}
          factoryId={auth.factoryId}
          equipmentId={equipment.id}
        />
        <EquipmentHistoryChart
          companyId={auth.companyId}
          factoryId={auth.factoryId}
          equipmentId={equipment.id}
        />
        <EquipmentTimelineChart
          companyId={auth.companyId}
          factoryId={auth.factoryId}
          equipmentId={equipment.id}
        />
      </Box>
    )}
    </>
  );
}
